<template>
<div id='mainDiv'>
  <div id='plusBox' @click="plus">
    <label id='plus'>+</label>
  </div>
  <hr>
  <div id='minusBox' @click = "minus">
    <label id='minus'>-</label>
  </div>
</div>
</template>

<script>
import { EventBus } from '@/eventBus.js';

export default {
  name: "MapZoomControl",
  methods: {

    plus() {
      EventBus.$emit('zoom', 1);
    },

    minus() {
      EventBus.$emit('zoom', -1);
    }
  }
}
</script>

<style scoped>
#mainDiv {
  margin: 0;
  z-index: 1;
  position: absolute;
  right: 20px;
  top: 20px;
  background-color: lightgrey;
  width: 40px;
  height: 81px;
  border: 1px solid black;
}

#plusBox {
  width: 40px;
  height: 40px;
}

#minusBox {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 41px;
}

#plusBox:hover label {
  color: darkGreen;
}

#minusBox:hover label {
  color: darkGreen;
}

label {
  position: absolute;
  margin: 0;
  height: 40px;
}


#plus {
  top: 0px;
  left: 10px;
  font-size: 35px;
}

#minus {
  top: -7px;
  left: 13px;
  font-size: 40px;
}

hr {
  width: 25px;
  position: absolute;
  margin: 0;
  top: 40px;
  left: 6px;
}
</style>
